import { Close, Delete } from "@mui/icons-material"
import AddIcon from "@mui/icons-material/Add"
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import DeleteIcon from "@mui/icons-material/Delete"
import EditIcon from "@mui/icons-material/Edit"
import VisibilityIcon from "@mui/icons-material/Visibility"
import {
  Checkbox,
  IconButton,
  List,
  ListItem,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import FormControl from "@mui/material/FormControl"
import MenuItem from "@mui/material/MenuItem"
import Modal from "@mui/material/Modal"
import Select from "@mui/material/Select"
import TextField from "@mui/material/TextField"
import axios from "axios"
import { useDebouncedQueryValue } from "Hooks/useDebouncedQueryValue"

import { flatten } from "lodash"
import React, { useEffect, useState } from "react"
import { useMutation, useQuery } from "react-query"
import ReactQuill from "react-quill"
import { toast } from "react-toastify"
import { deletePlanFn, getPlanFn, getPlanModuleFn, getPlanTypeFn, patchPlanFn, postPlanFn } from "Services/Plan Management"
import CustomSelect from "Shared/CustomSelect"
import SelectInput from "Shared/SelectInput"

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
}

const Plan = () => {

  const [open, setOpen] = React.useState(false)
  const [open1, setOpen1] = React.useState(false)
  const [open2, setOpen2] = React.useState(false)
  const [page, setPage] = useState(1)
  const [searchQuery, setSearchQuery] = useState("")
  const [page1, setPage1] = useState(1)
  const [searchQuery1, setSearchQuery1] = useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPage, setTotalPage] = useState(null)
  const [currentPage1, setCurrentPage1] = useState(1)
  const [totalPage1, setTotalPage1] = useState(null)
  const [planId, setPlanId] = useState("")
  const [hideValue, setHideValue] = useState({})
  const [planData, setPlanData] = useState([])
  const [viewData, setViewData] = useState([])
  const [details, setDetails] = useState([])
  const [formValues, setFormValues] = useState([])
  const [planName, setPlanName] = useState("")

  const [quterly_price1, setQuterly_price1] = useState("")
  const [quterly_price1USD, setQuterly_price1USD] = useState("")
  const [yearlyPrice, setYearlyPrice] = useState("")
  const [yearlyPriceUSD, setYearlyPriceUSD] = useState("")
  const [userNo, setUserNo] = useState("")
  const [module, setModule] = useState([])
  const [selectedModule, setSelectedModule] = useState([])
  const [planName1, setPlanName1] = useState("")

  const [quterly_price, setQuterly_price] = useState("")
  const [quterly_priceUSD, setQuterly_priceUSD] = useState("")
  const [yearlyPrice1, setYearlyPrice1] = useState("")
  const [yearlyPrice1USD, setYearlyPrice1USD] = useState("")
  const [userNo1, setUserNo1] = useState("")
  const [editModule, setEditModule] = useState([])
  const [module1, setModule1] = useState([])
  const [selectedModule1, setSelectedModule1] = useState([])
  const [inputs, setInputs] = useState([])
  const [ids, setIds] = useState(null)
  const [selectedUpdateModule, setSelectedUpdateModule] = useState([])
  const [description, setDescription] = useState("")
  const [planvalidity, setPlanValidity] = useState("")
  const [plantype, setPlanType] = useState(null)
  const [packagetype, setPackageType] = useState("")
  const [price, setPrice] = useState("")
  const [mrp, setMrp] = useState("")

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const handleOpen1 = () => setOpen1(true)
  const handleClose1 = () => {
    setOpen1(false)
    setDescription("")
  }
  const handleOpen2 = () => setOpen2(true)
  const handleClose2 = () => setOpen2(false)


  const handleClearForm = () => {
    setIds(null);
    setSelectedModule([]);
    setPrice("");
    setMrp("");
    setDescription("");
    setPlanName("");
    setPackageType("");
    setPlanType("");
    setPlanValidity("");
    handleClose()
  };


  const debounce = useDebouncedQueryValue(searchQuery, 500)

  const { data, refetch } = useQuery(["PlanList", page, debounce], () => getPlanFn({ search: debounce, page: page }))

  const PlanData = data?.data?.data

  const { mutate: AddPlan } = useMutation(postPlanFn, {
    onSuccess: (data) => {

      if (data?.data?.response_code === 200) {

        toast.success(data?.data?.message)
        setSelectedModule([])
        handleClose1()
        handleClose()
        handleClearForm()
        refetch()


      }


      else {

        toast.warn(data?.data?.message)



      }




    }
  })



  const { mutate: UpdatePlan } = useMutation(patchPlanFn, {
    onSuccess: (data) => {

      if (data?.data?.response_code === 200) {

        toast.success(data?.data?.message)
        setSelectedModule([])

        handleClose()
        handleClearForm()
        refetch()


      }


      else {

        toast.warn(data?.data?.message)



      }


    }
  })


  const { mutate: DeletePlan } = useMutation(deletePlanFn, {
    onSuccess: (data) => {

      if (data?.data?.response_code === 200) {

        toast.success(data?.data?.message)
        refetch()




      }


      else {

        toast.warn(data?.data?.message)



      }


    }
  })





  const PLAN_VALIDITY = ['One Month', 'Three Month', 'Six Month', 'One Year'];
  const validityOptions = PLAN_VALIDITY.map((item) => ({
    value: item,
    label: item,
  }));



  const { data: M } = useQuery(["module"], () => getPlanModuleFn())

  const ModuleData = M?.data?.data

  const { data: P } = useQuery(["planType"], () => getPlanTypeFn())

  const PlanTypeData = P?.data?.data

  const handleCloseModal = () => {
    setIds(null)
    setDescription("")
    handleClose()
  }

  const submitData = () => {
    const formData = {
      planmodule: selectedModule,
      plan_type: plantype,
      plan_validity: planvalidity,
      plan_name: planName,
      price: Number(price),
      mrp: Number(mrp),
      description: description,
      package_type: packagetype,
      plan_id: ids,
    }

    ids === null ? AddPlan(formData) : UpdatePlan(formData)

  }



  const handleViewDetail = (event, row) => {
    event.preventDefault()
    setViewData(row)
    handleOpen1()
  }








  const editDataList = (row) => {
    setIds(row?.id)
    setSelectedModule(row?.planmodule)
    setPrice(row?.price)
    setMrp(row?.mrp)
    setDescription(row?.description)
    setPlanName(row?.plan_name)
    setPackageType(row?.package_type)
    setPlanType(row?.plan_type)
    setPlanValidity(row?.plan_validity)
    handleOpen()

  }






  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">Plan Management List</p>
        </div>
        <div className="p-2 pt-5">
          <Button variant="outlined" color="primary" onClick={handleOpen}>
            <AddIcon />
            Add Plan
          </Button>
        </div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-2">
          <span className="flex gap-3">
            <input
              class="placeholder:italic placeholder:text-slate-400 block mx-3 bg-white w-80 border border-slate-300 rounded-md py-2 px-2 pr-3 shadow-sm focus:outline-none focus:border-slate-600 focus:ring-slate-500 focus:ring-1 sm:text-sm"
              placeholder="Search for anything..."
              type="text"
              value={searchQuery}
              onChange={(event) => setSearchQuery(event.target.value)}
            />
          </span>

          <Modal
            open={open}
            onClose={handleClearForm}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
          >
            <Box
              sx={{ ...style }}
              className="rounded-2xl !outline-none !w-1/2 !h-5/6 !border-0 !shadow-sm !shadow-blue-900 overflow-auto"
            >
              <p className="!text-black !underline !underline-offset-2  !font-bold pb-3 !text-center !text-xl">
                {ids === null ? "Add Plan" : "Update Plan"}
              </p>
              <div className="flex flex-col gap-2">
                <div className="!w-full">
                  <p>Plan Name </p>
                  <TextField
                    value={planName}
                    onChange={(event) => setPlanName(event.target.value)}
                    id="outlined-basic"
                    size="small"
                    className="!w-[100%]"
                    placeholder="Enter Plan Name"
                  />
                </div>

                <div className="flex justify-between w-full gap-4">

                  <div className="!w-full">
                    <p>Price </p>
                    <TextField
                      value={price}
                      onChange={(event) => setPrice(event.target.value)}
                      id="outlined-basic"
                      size="small"
                      type="number"
                      className="!w-[100%]"
                      placeholder="Enter Price"
                    />
                  </div>
                  <div className="!w-full">
                    <p>MRP </p>
                    <TextField
                      value={mrp}
                      onChange={(event) => setMrp(event.target.value)}
                      id="outlined-basic"
                      size="small"
                      type="number"
                      className="!w-[100%]"
                      placeholder="Enter MRP"
                    />
                  </div>



                </div>

                <div className="flex justify-between w-full gap-4">
                  {/* <div className="!w-full">
                    <p>Monthly Price </p>
                    <TextField
                      value={monthlyPrice}
                      onChange={(event) => setMonthlyPrice(event.target.value)}
                      id="outlined-basic"
                      size="small"
                      className="!w-[100%]"
                      placeholder="Enter Monthly Price "
                    />
                  </div> */}

                  <div className="!w-full">

                    <CustomSelect
                      fullWidth
                      id="plan_validity"
                      name="plan_validity"
                      label="Plan Validity"
                      value={planvalidity}
                      onChange={(e) => setPlanValidity(e.target.value)}
                      options={validityOptions || []}

                    />
                  </div>
                  <div className="!w-full">
                    <CustomSelect
                      fullWidth
                      id="Package_type"
                      name="Package_type"
                      label="Package Type"
                      value={packagetype}
                      onChange={(e) => setPackageType(e.target.value)}

                    >

                      {["Leads", "SpecialOffer"]?.map((i) => {
                        return (<MenuItem value={i}>
                          {i}



                        </MenuItem>)



                      })}

                    </CustomSelect>
                  </div>
                </div>

                <div className="!w-full">
                  <CustomSelect
                    fullWidth
                    id="plan_type"
                    name="plan_type"
                    label="Plan Type"
                    value={plantype}
                    onChange={(e) => setPlanType(e.target.value)}

                  >

                    {PlanTypeData?.map((i) => {
                      return (<MenuItem value={i.id}>
                        {i?.name}



                      </MenuItem>)



                    })}

                  </CustomSelect>
                </div>












                <List className="!grid !grid-cols-2 !border">
                  {ModuleData?.map((elem) => {
                    const isChecked = selectedModule.includes(elem.id);

                    const handleCheckboxChange = (event) => {
                      if (event.target.checked) {
                        setSelectedModule((prev) => [...prev, elem.id]);
                      } else {
                        setSelectedModule((prev) => prev.filter((id) => id !== elem.id));
                      }
                    };

                    return (
                      <ListItem key={elem.id} className="!flex !items-center">
                        <Checkbox
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                        {elem.name}
                      </ListItem>
                    );
                  })}
                </List>



                <div className="flex flex-col">
                  <p>Description</p>
                  <ReactQuill placeholder="Enter Module Descriptions" value={description} onChange={setDescription} />
                </div>
              </div>
              <br />
              <span className="flex justify-end gap-5">
                <Button size="small" onClick={handleClearForm} variant="contained" color="inherit" className="w-32">
                  CANCEL
                </Button>
                <Button size="small" variant="contained" color="success" className="w-32" onClick={submitData}>
                  {ids === null ? "Add" : "Update"}
                </Button>
              </span>
            </Box>
          </Modal>



          <Modal
            open={open1}
            onClose={handleClose1}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
          >
            <Box sx={{ ...style }} className="rounded-md w-1/2 !p-2 !border-0 !shadow-blue-900">
              <div className="flex items-center justify-between">
                {/* <div className="!text-black !font-bold px-3 !text-xl">
                  {viewData?.plan_name}({viewData?.plan_type})
                </div> */}
                <IconButton onClick={handleClose1}>
                  <Close />
                </IconButton>
              </div>
              {/* <span className="flex gap-3 py-2">
                <input
                  class="placeholder:italic placeholder:text-slate-400 block bg-white w-80 border border-slate-300 rounded-md py-2 px-2 pr-3 shadow-sm focus:outline-none focus:border-slate-600 focus:ring-slate-500 focus:ring-1 sm:text-sm"
                  placeholder="Search for anything..."
                  type="text"
                  value={searchQuery1}
                  onChange={(event) => setSearchQuery1(event.target.value)}
                />
              </span> */}
              <TableContainer
                component={Paper}
                sx={{ width: "100%", maxHeight: 440 }}
                className="!text-black !mx-auto !bg-white overflow-auto !shadow-none "
              >
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead className="!bg-slate-700 !px-0 !mx-0">
                    <TableRow className="!bg-slate-700">
                      <TableCell
                        style={{
                          borderRight: "1px solid #D0D0D0",
                        }}
                        className="!text-center !text-white !bg-slate-800 !font-bold"
                      >
                        SR. No.
                      </TableCell>
                      <TableCell
                        style={{
                          borderRight: "1px solid #D0D0D0",
                        }}
                        className="!text-center !bg-slate-800 !text-white !font-bold"
                      >
                        MODULE
                      </TableCell>
                      {/* <TableCell style={{}} className="!text-center !bg-slate-800 !text-white !font-bold">
                        VALUE
                      </TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody className="!bg-red">
                    {viewData &&
                      viewData?.map((row, index) => (
                        <TableRow key={row.id} className="!text-slate-700 ">
                          <TableCell
                            className="!text-center !text-[12px]"
                            style={{
                              borderRight: "1px solid #D0D0D0",
                            }}
                          >
                            {index + 1}
                          </TableCell>
                          <TableCell
                            className="!text-center !text-[12px]"
                            style={{
                              borderRight: "1px solid #D0D0D0",
                            }}
                          >
                            {row?.name ? row?.name : "--"}
                          </TableCell>
                          {/* <TableCell className="!text-center !text-[12px]" style={{}}>
                            {row?.value ? row?.value : "--"}
                          </TableCell> */}
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>

            </Box>
          </Modal>
          {/* view visible view  end*/}
        </div>
        <TableContainer
          component={Paper}
          sx={{ width: "100%", maxHeight: 440 }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  SR. No.
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  PLAN NAME
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  PLAN TYPE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  MODULE
                </TableCell>
                {/* <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  MONTHLY PRICE
                </TableCell> */}
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  MRP
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  PRICE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  Plan Validity
                </TableCell>
                <TableCell style={{}} className="!text-center !text-gray-800 !font-bold">
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              {PlanData &&
                PlanData?.map((row, index) => (
                  <TableRow key={row.id} className="!text-slate-700">
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                      }}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                      }}
                    >
                      {row?.plan_name ? row?.plan_name : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                      }}
                    >
                      {row?.plan_type_name ? row?.plan_type_name : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                      }}
                    >
                      <VisibilityIcon onClick={(event) => handleViewDetail(event, row?.planmodule_data)} className="cursor-pointer" />
                    </TableCell>
                    {/* <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                      }}
                    >
                      {row?.monthly_price ? <span className="text-green-500">₹ {row?.monthly_price}</span> : "--"}
                    </TableCell> */}

                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                      }}
                    >
                      {row?.price ? <span className="text-green-500">₹ {row?.price}</span> : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                      }}
                    >
                      {row?.mrp ? <span className="text-green-500">₹ {row?.mrp}</span> : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                      }}
                    >
                      {row?.plan_validity
                        ? row?.plan_validity
                        : "--"}
                    </TableCell>
                    <TableCell className="!text-center !text-[12px] space-x-5">
                      <EditIcon
                        className="!text-xl !cursor-pointer !text-green-600"
                        onClick={() => editDataList(row)}
                      />

                      <Delete
                        className="!text-xl !cursor-pointer !text-red-500"
                        onClick={() => DeletePlan({ plan_id: row?.id })}
                      />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div
          className="!float-right relative bg-white w-[100%] mx-auto bottom-0 right-0 py-3 border-t-2 border-gray-400  flex !flex-col !justify-end !items-end"
          style={{ marginRight: "0px" }}
        >


          <Pagination count={data?.data?.total_pages} value={data?.data?.current_page} onChange={(_, value) => setPage(value)} variant="outlined" shape="rounded" />

        </div>
      </div>
    </div>
  )
}

export default Plan
